<template>
  <v-app-bar color="white" app dark :class="isMobile() ? 'primary' : ''">
    <template v-if="isMobile()">
      <v-app-bar-nav-icon @click="setDrawer(true)"></v-app-bar-nav-icon>
      <v-img
        class="mx-2"
        src="@/assets/logo_simple.png"
        max-height="35"
        max-width="35"
        contain
      ></v-img>
      <v-toolbar-title class="ml-2"> Portal do Colaborador</v-toolbar-title>
    </template>
    <v-chip v-if="isDevelopment()" class="mr-4" color="orange"
      >BASE DESENVOLVIMENTO</v-chip
    >
    <v-spacer></v-spacer>
    <alerta-notificacao v-if="!gerencial" />
  </v-app-bar>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import AlertaNotificacao from "../components/AlertaNotificacao.vue";

export default {
  components: { AlertaNotificacao },
  computed: mapState("usuario", ["gerencial"]),
  methods: {
    ...mapMutations("usuario", ["setDrawer"]),
    isMobile() {
      return this.$mq === "sm" || this.$mq === "md";
    },
    isDevelopment() {
      return process.env.NODE_ENV === "development";
    },
  },
};
</script>

<style>
</style>